import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allWorkspacesAreSelected, someWsIsSelected } from 'store/Workspace/selectors';
import { selectAllWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import SelectionHeader from 'shared/ui/Table/cells/SelectionHeader';

const CheckHeader = () => {
  const allWorkspacesSelected = useSelector(allWorkspacesAreSelected);
  const someWsSelected = useSelector(someWsIsSelected);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(selectAllWorkspaces());
  };

  return (
    <SelectionHeader onChange={ handleClick } checked={ allWorkspacesSelected } indeterminate={ someWsSelected && !allWorkspacesSelected } />
  );
};

export default CheckHeader;
